// Mirror of server-side kit_staging/move_rules.py for UI rule lookups.

export type Area = 'unassigned' | 'cart' | 'msa' | 'jsa' | 'dekit';
export const MACHINE = 'machine' as const;
export type Destination = Area | typeof MACHINE;
export type Rule = 'SINGLE' | 'DUAL' | 'DUAL_LOCAL' | 'SINGLE_ERP' | 'NOT_ALLOWED';

const RULES: Record<string, Rule> = {
	'unassigned->cart': 'SINGLE',
	'unassigned->msa': 'DUAL',
	'unassigned->jsa': 'DUAL',
	'unassigned->dekit': 'SINGLE',
	'unassigned->machine': 'DUAL',
	'cart->unassigned': 'SINGLE',
	'cart->msa': 'DUAL',
	'cart->jsa': 'DUAL',
	'cart->dekit': 'SINGLE',
	'cart->machine': 'DUAL',
	'msa->unassigned': 'SINGLE',
	'msa->msa': 'SINGLE',
	'msa->cart': 'SINGLE',
	'msa->jsa': 'DUAL',
	'msa->dekit': 'SINGLE',
	'msa->machine': 'DUAL_LOCAL',
	'jsa->unassigned': 'SINGLE',
	'jsa->jsa': 'SINGLE',
	'jsa->dekit': 'SINGLE',
	'jsa->machine': 'SINGLE_ERP',
};

// Status-conditional overrides — kept in sync with
// server/kit_staging/move_rules.STATUS_OVERRIDES.
//   jsa->jsa, site_mismatch -> DUAL
//     A site-mismatch JSA→JSA move is a deliberate reroute; require
//     two-step confirmation so the operator can abort and the
//     destination tablet can confirm.
//   jsa->jsa, issue -> DUAL
//     Returning a return-kit issue card to JSA (it's at the machine,
//     soft-hidden) is a deliberate "Return to JSA" — require confirm on
//     the JSA page rather than a one-tap relocate.
const STATUS_OVERRIDES: Record<string, Rule> = {
	'jsa->jsa|site_mismatch': 'DUAL',
	'jsa->jsa|issue': 'DUAL',
};

export function lookup(from: Area, to: Destination, status?: string | null): Rule {
	if (status) {
		const override = STATUS_OVERRIDES[`${from}->${to}|${status}`];
		if (override) return override;
	}
	return RULES[`${from}->${to}`] ?? 'NOT_ALLOWED';
}

export function legalDestinations(from: Area): Destination[] {
	// Allow same-area moves (reshelving) when explicitly enabled in the matrix.
	return (['cart', 'msa', 'jsa', 'dekit', 'unassigned', MACHINE] as Destination[]).filter(
		(to) => lookup(from, to) !== 'NOT_ALLOWED',
	);
}
